export const capitalizeWord = (value: string): string => {
    if (typeof value !== 'string') return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
}

export const capitalizeWords = (input?: string | null): string => {
    if (!input) return ''
    let oldStrArr = input.split(' ');
    let newStrArr = oldStrArr.map((str)=>{
        str = str.toLowerCase();
        return str.charAt(0).toUpperCase() + str.slice(1);
    });
    return newStrArr.join(' ');    
}

export const pluralizeWord = (word: string, count: number): string => {
    return count > 1 || count === 0 ? `${word}s` : word;
}

type OptionalField = string | undefined | null

export const formatAddress = (address?: OptionalField, city?: OptionalField, state?: OptionalField, zip?: OptionalField, country?: OptionalField): string => {
    return `${address ? `${address},` : ''} ${city ? `${city},` : ''} ${state ? `${state}` : ''} ${zip ? `${zip}` : ''}${country ? `, ${country}` : ''}`
}

export const formatSnakeCase = (value: string): string => {
    return value  
        .split('_')  
        .map((word) => {  
            return capitalizeWord(word);  
        })  
        .join(' ');
}

export const sanitizeURL= (str: any): string => {
    if (str===null||typeof str === 'undefined') return str as unknown as string
    const regex = /[^a-zA-Z0-9-]+/g; // regex to match all characters except alphanumeric and space
    const trimmedStr = str.trim(); // remove spaces at beginning and end of the string
    const sanitizedStr = trimmedStr.replace(regex, ""); // replace all invalid characters with hyphens
    const singleSpacedStr = sanitizedStr.replace(/\s+/g, ""); // replace multiple spaces with single spaces
    return singleSpacedStr; // return sanitized string
}

export const sanitizeEmail = (str: any): string => {
    if (str===null||typeof str === 'undefined') return str as unknown as string
    const regex = /[^a-zA-Z0-9\-_.@+]+/g; // allow common email alias character '+'
    const trimmedStr = str.trim(); // remove spaces at beginning and end of the string
    const sanitizedStr = trimmedStr.replace(regex, ""); // replace all invalid characters with hyphens
    const singleSpacedStr = sanitizedStr.replace(/\s+/g, ""); // replace multiple spaces with single spaces
    return singleSpacedStr; // return sanitized string
}

export const sanitizeString = (str: any): string => {
    if (str===null||typeof str === 'undefined') return str as unknown as string
    const regex = /[^a-zA-Z0-9 -.,()&@#!?$='"%]+/g; // regex to match all characters except alphanumeric and space
    const trimmedStr = str.trim(); // remove spaces at beginning and end of the string
    const sanitizedStr = trimmedStr.replace(regex, ""); // replace all invalid characters with hyphens
    const singleSpacedStr = sanitizedStr.replace(/\s+/g, " "); // replace multiple spaces with single spaces
    return singleSpacedStr; // return sanitized string
}

export const sanitizeStringAllowSpace = (str: any): string => {
    if (str===null||typeof str === 'undefined') return str as unknown as string
    const regex = /[^a-zA-Z0-9 -.,()&@#!?$='"%]+/g; // regex to match all characters except alphanumeric and space
    const trimmedStr = str
    const sanitizedStr = trimmedStr.replace(regex, ""); // replace all invalid characters with hyphens
    const singleSpacedStr = sanitizedStr.replace(/\s+/g, " "); // replace multiple spaces with single spaces
    return singleSpacedStr; // return sanitized string
}

export function getFirstLetters(str: string | null = '', num: number = 0): string {
    // Ensure the inputs are valid
    if (typeof str !== 'string' || typeof num !== 'number' || num < 0) {
        return '';
    }
    
    // Return the first 'num' characters of 'str'
    return str.slice(0, num);
}

export function toPgUuidArrayLiteral(input: string | undefined | null) {
    if (!input || typeof input !== "string") return "{}";

    // Split, trim, and filter out any empty parts
    const ids = input
        .split(",")
        .map(s => s.trim())
        .filter(Boolean);

    // Join into Postgres array literal format
    return `{${ids.join(",")}}`;
}

/**
 * Converts a file size in bytes into a human-readable string.
 * Example: 1048576 → "1 MB"
 */
export function formatFileSize(bytes: number, decimals = 1): string {
    if (!bytes || bytes === 0) return '0 B';
  
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
  
    return `${size} ${sizes[i]}`;
  }